// import { useSelector } from "react-redux";

// export function usePermissions() {
//   const privileges = useSelector(
//     (state) => state?.privilegesReducer?.rbacPrivileges,
//   );
//   function hasPermission(permission, eitherOr) {
//     if (eitherOr === "eitherOr") {
//       return permission.some((p) => privileges.includes(p));
//     }
//     return permission.every((p) => privileges.includes(p));
//   }

//   return { hasPermission, privileges };
// }


import { useSelector } from "react-redux";

const normalizePrivileges = (value) => {
  if (typeof value === "string") {
    return value
      .split(",")
      .map((privilege) => privilege.trim())
      .filter(Boolean);
  }

  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }

  return [];
};

export function usePermissions() {
  const rbacPrivileges = useSelector(
    (state) => state?.privilegesReducer?.rbacPrivileges,
  );

  const apiPrivileges = useSelector(
    (state) => state?.authReducer?.userData?.productPrivileges,
  );

  const privileges =
    normalizePrivileges(rbacPrivileges).length > 0
      ? normalizePrivileges(rbacPrivileges)
      : normalizePrivileges(apiPrivileges);

  const hasPermission = (permission, eitherOr) => {
    if (!permission) {
      return false;
    }

    const requiredPrivileges = Array.isArray(permission)
      ? permission
      : [permission];

    if (eitherOr === "eitherOr") {
      return requiredPrivileges.some((privilege) =>
        privileges.includes(privilege),
      );
    }

    return requiredPrivileges.every((privilege) =>
      privileges.includes(privilege),
    );
  };

  return {
    hasPermission,
    privileges,
  };
}